export default "__VITE_ASSET__DIR469LG__"